import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Règlement d’éligibilité structuré d’un mécanisme d’allocation.
 */
export default function MechanismEligibilityEditor({ value, onChange, disabled = false }) {
  const { t } = useTranslation('common');
  const form = value || {
    text: '',
    minimum_seniority_months: '',
    require_active_status: true,
    contribution_situation_mode: 'inherit',
  };

  const patch = (partial) => onChange?.({ ...form, ...partial });

  return (
    <div className="space-y-3 rounded-xl border border-slate-200 bg-slate-50/40 p-3 sm:p-3.5">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
          {t('assistanceManagement.eligibilityTitle')}
        </p>
        <p className="mt-0.5 text-xs text-slate-500">{t('assistanceManagement.eligibilityHint')}</p>
      </div>

      <textarea
        value={form.text}
        disabled={disabled}
        onChange={(e) => patch({ text: e.target.value })}
        placeholder={t('assistanceManagement.placeholderEligibility')}
        className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"
        rows={3}
      />

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="block space-y-1 text-xs font-medium text-slate-600">
          <span>{t('assistanceManagement.eligibilitySeniorityLabel')}</span>
          <input
            type="number"
            min={0}
            disabled={disabled}
            value={form.minimum_seniority_months}
            onChange={(e) => patch({ minimum_seniority_months: e.target.value })}
            placeholder={t('assistanceManagement.eligibilitySeniorityPlaceholder')}
            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"
          />
          <span className="block text-[11px] font-normal text-slate-500">
            {t('assistanceManagement.eligibilitySeniorityHelp')}
          </span>
        </label>

        <label className="block space-y-1 text-xs font-medium text-slate-600">
          <span>{t('assistanceManagement.eligibilityContribLabel')}</span>
          <select
            disabled={disabled}
            value={form.contribution_situation_mode || 'inherit'}
            onChange={(e) => patch({ contribution_situation_mode: e.target.value })}
            className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm"
          >
            <option value="inherit">{t('assistanceManagement.eligibilityContribInheritOpt')}</option>
            <option value="auto">{t('assistanceManagement.eligibilityContribAutoOpt')}</option>
            <option value="off">{t('assistanceManagement.eligibilityContribOffOpt')}</option>
          </select>
        </label>
      </div>

      <label className="flex items-start gap-2 text-sm text-slate-700">
        <input
          type="checkbox"
          className="mt-0.5 h-4 w-4 rounded border-slate-300 text-[#2f6fd4] focus:ring-[#2f6fd4]"
          checked={form.require_active_status !== false}
          disabled={disabled}
          onChange={(e) => patch({ require_active_status: e.target.checked })}
        />
        <span>
          <span className="font-medium">{t('assistanceManagement.eligibilityActiveLabel')}</span>
          <span className="mt-0.5 block text-xs text-slate-500">
            {t('assistanceManagement.eligibilityActiveHelp')}
          </span>
        </span>
      </label>
    </div>
  );
}
